export const SCOPE_ALL = "*";
export const MAX_TOKEN_LIFE = 90; // days
export const DOES_NOT_EXPIRE = "DOES_NOT_EXPIRE";

export const API_SERVICES = {
  REST_API: "rest_api",
  WEBAPP: "webapp",
};

export const API_TOKEN_SCOPE_KEYS = {
  SERVICES: "services",
  WORKSPACES: "workspaces",
};
